import { useEffect, useRef } from "react";
import { useWSQuery } from "../../query/helpers";

type Query = ReturnType<typeof useWSQuery>;

// Extract data type from a query
type ExtractQueryData<T> = T extends { data: infer D } ? D : never;

// Map tuple of queries to tuple of their data types
type ExtractQueriesData<T extends readonly Query[]> = {
  [K in keyof T]: ExtractQueryData<T[K]>;
};

export const useOnQueriesFetched = <TQueries extends [Query, ...Query[]]>(
  callback: (...data: ExtractQueriesData<TQueries>) => void,
  ...queries: TQueries
) => {
  const isTriggered = useRef(false);
  const isAllFetched = queries.every(query => query.isFetched);

  useEffect(() => {
    if (isAllFetched && !isTriggered.current) {
      isTriggered.current = true;
      const data = queries.map(q => q.data) as ExtractQueriesData<TQueries>;
      callback(...data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAllFetched, callback]);
};
